import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import __ from "src/utils/Translations";
import { blueGrey } from "@mui/material/colors";
import { IAreaMembers } from "src/Pages/Company/OrganizationStructure/Areas/Area.models";
import { Avatar, PresenceIndicator } from "@benefit-systems/hr-tools-ui";
import { PresenceInformation } from "src/Components/Avatar/presenceColor/models/employeePresence.models";

interface IEmployeeChip {
  employeeName: string | null;
  fk: string | null;
  position: string | null;
  area: string | null;
  initials: string;
  avatar: string | undefined;
  employeeId: string;
  presenceInformation?: PresenceInformation;
  isInvalid?: boolean;
}

const EmployeeChip: FC<IEmployeeChip> = ({
  employeeName,
  fk,
  position,
  area,
  initials,
  avatar,
  employeeId,
  presenceInformation,
  isInvalid = false,
}) => {
  const { setValue, getValues } = useFormContext();

  const handleRemove = () => {
    const currentMembers = getValues("members");
    const updatedMembers = currentMembers.filter(
      (member: IAreaMembers) => member.id !== employeeId
    );
    setValue("members", updatedMembers, { shouldDirty: true });
  };

  return (
    <Box
      sx={{
        padding: "12px 16px",
        height: "78px",
        borderRadius: "12px",
        boxShadow:
          "0px 1px 1px 0px #F2F2F2, 0px 4px 24px 0px rgba(166, 166, 166, 0.2)",
        display: "flex",
        backgroundColor: isInvalid ? "rgba(211, 47, 47, 0.04)" : "transparent",
        border: isInvalid ? "1px solid #D32F2F" : "1px solid #F2F2F2",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Box
        sx={{ display: "flex", alignItems: "center", gap: "8px", flexGrow: 1 }}
      >
        <PresenceIndicator status={presenceInformation?.status}>
          <Avatar alt={__("Avatar pracownika")} src={avatar}>
            {initials}
          </Avatar>
        </PresenceIndicator>
        <Box>
          <Typography sx={{ m: 0, fontSize: "14px", lineHeight: "16px" }}>
            <b>{employeeName}</b>{" "}
            <Box component="span" color={blueGrey["500"]}>{`(FK ${fk})`}</Box>
          </Typography>
          {position && (
            <Typography
              color={blueGrey["500"]}
              sx={{
                m: 0,
                fontSize: "12px",
                lineHeight: "14px",
              }}
            >
              {position}
            </Typography>
          )}
          {area && (
            <Typography
              color={blueGrey["500"]}
              sx={{
                m: 0,
                fontSize: "12px",
                lineHeight: "14px",
              }}
            >
              {area}
            </Typography>
          )}
        </Box>
      </Box>
      <IconButton onClick={handleRemove}>
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

export default EmployeeChip;
